import * as Atdgen_codec_runtime from "@ahrefs/bs-atdgen-codec-runtime/src/atdgen_codec_runtime.bs.js";
import * as Bigdata_bs$SolvuuApi0 from "./bigdata_bs.bs.js";

function write__1(param) {
  return Atdgen_codec_runtime.Encode.list(Atdgen_codec_runtime.Encode.string, param);
}

function read__1(param) {
  return Atdgen_codec_runtime.Decode.list(Atdgen_codec_runtime.Decode.string, param);
}

var write_bigdata = Bigdata_bs$SolvuuApi0.write_t$prime;
var read_bigdata = Bigdata_bs$SolvuuApi0.read_t$prime;

function write_frames(write__int32_genarray, write__int64_genarray, write__float32_genarray, write__float64_genarray) {
  var write__a = write__int32_genarray;
  var write__b = write__int64_genarray;
  var write__c = write__float32_genarray;
  var write__d = write__float64_genarray;
  var partial_arg = write_bigdata(write__a, write__b, write__c, write__d);

  var partial_arg$1 = function partial_arg$1(param) {
    return Atdgen_codec_runtime.Encode.tuple2(write__1, partial_arg, param);
  };

  return function (param) {
    return Atdgen_codec_runtime.Encode.list(partial_arg$1, param);
  };
}

function read_frames(read__int32_genarray, read__int64_genarray, read__float32_genarray, read__float64_genarray) {
  var read__a = read__int32_genarray;
  var read__b = read__int64_genarray;
  var read__c = read__float32_genarray;
  var read__d = read__float64_genarray;
  var partial_arg = read_bigdata(read__a, read__b, read__c, read__d);

  var partial_arg$1 = function partial_arg$1(param) {
    return Atdgen_codec_runtime.Decode.tuple2(read__1, partial_arg, param);
  };

  return function (param) {
    return Atdgen_codec_runtime.Decode.list(partial_arg$1, param);
  };
}

function write_indexed(write__int32_genarray, write__int64_genarray, write__float32_genarray, write__float64_genarray) {
  return Atdgen_codec_runtime.Encode.make(function (t) {
    return Atdgen_codec_runtime.Encode.obj(
    /* :: */
    [Atdgen_codec_runtime.Encode.field(undefined, write_frames(write__int32_genarray, write__int64_genarray, write__float32_genarray, write__float64_genarray), "indexed", t.indexed),
    /* :: */
    [Atdgen_codec_runtime.Encode.field(undefined, write_frames(write__int32_genarray, write__int64_genarray, write__float32_genarray, write__float64_genarray), "index", t.index),
    /* :: */
    [Atdgen_codec_runtime.Encode.field(undefined, write_frames(write__int32_genarray, write__int64_genarray, write__float32_genarray, write__float64_genarray), "data", t.data),
    /* [] */
    0]]]);
  });
}

function read_indexed(read__int32_genarray, read__int64_genarray, read__float32_genarray, read__float64_genarray) {
  return Atdgen_codec_runtime.Decode.make(function (json) {
    var partial_arg = read_frames(read__int32_genarray, read__int64_genarray, read__float32_genarray, read__float64_genarray);
    var partial_arg$1 = read_frames(read__int32_genarray, read__int64_genarray, read__float32_genarray, read__float64_genarray);
    var partial_arg$2 = read_frames(read__int32_genarray, read__int64_genarray, read__float32_genarray, read__float64_genarray);
    return {
      indexed: Atdgen_codec_runtime.Decode.decode(function (param) {
        return Atdgen_codec_runtime.Decode.field("indexed", partial_arg, param);
      }, json),
      index: Atdgen_codec_runtime.Decode.decode(function (param) {
        return Atdgen_codec_runtime.Decode.field("index", partial_arg$1, param);
      }, json),
      data: Atdgen_codec_runtime.Decode.decode(function (param) {
        return Atdgen_codec_runtime.Decode.field("data", partial_arg$2, param);
      }, json)
    };
  });
}

function write_term(write__int32_genarray, write__int64_genarray, write__float32_genarray, write__float64_genarray) {
  return Atdgen_codec_runtime.Encode.make(function (x) {
    if (x[0] >= -43001707) {
      return Atdgen_codec_runtime.Encode.constr1("Indexed_dataframe", write_indexed(write__int32_genarray, write__int64_genarray, write__float32_genarray, write__float64_genarray), x[1]);
    } else {
      return Atdgen_codec_runtime.Encode.constr1("Frames", write_frames(write__int32_genarray, write__int64_genarray, write__float32_genarray, write__float64_genarray), x[1]);
    }
  });
}

function read_term(read__int32_genarray, read__int64_genarray, read__float32_genarray, read__float64_genarray) {
  var partial_arg = read_frames(read__int32_genarray, read__int64_genarray, read__float32_genarray, read__float64_genarray);
  var partial_arg$1 = read_indexed(read__int32_genarray, read__int64_genarray, read__float32_genarray, read__float64_genarray);
  return Atdgen_codec_runtime.Decode.$$enum(
  /* :: */
  [
  /* tuple */
  ["Frames",
  /* `Decode */
  [427938126, function (param) {
    return Atdgen_codec_runtime.Decode.map(function (x) {
      return (
        /* `Frames */
        [-518380602, x]
      );
    }, partial_arg, param);
  }]],
  /* :: */
  [
  /* tuple */
  ["Indexed_dataframe",
  /* `Decode */
  [427938126, function (param) {
    return Atdgen_codec_runtime.Decode.map(function (x) {
      return (
        /* `Indexed_dataframe */
        [-43001707, x]
      );
    }, partial_arg$1, param);
  }]],
  /* [] */
  0]]);
}

function write_indexed_term(write__int32_genarray, write__int64_genarray, write__float32_genarray, write__float64_genarray) {
  return Atdgen_codec_runtime.Encode.make(function (x) {
    return Atdgen_codec_runtime.Encode.constr1("Indexed_dataframe", write_indexed(write__int32_genarray, write__int64_genarray, write__float32_genarray, write__float64_genarray), x[1]);
  });
}

function read_indexed_term(read__int32_genarray, read__int64_genarray, read__float32_genarray, read__float64_genarray) {
  var partial_arg = read_indexed(read__int32_genarray, read__int64_genarray, read__float32_genarray, read__float64_genarray);
  return Atdgen_codec_runtime.Decode.$$enum(
  /* :: */
  [
  /* tuple */
  ["Indexed_dataframe",
  /* `Decode */
  [427938126, function (param) {
    return Atdgen_codec_runtime.Decode.map(function (x) {
      return (
        /* `Indexed_dataframe */
        [-43001707, x]
      );
    }, partial_arg, param);
  }]],
  /* [] */
  0]);
}

function write_frames_term(write__int32_genarray, write__int64_genarray, write__float32_genarray, write__float64_genarray) {
  return Atdgen_codec_runtime.Encode.make(function (x) {
    return Atdgen_codec_runtime.Encode.constr1("Frames", write_frames(write__int32_genarray, write__int64_genarray, write__float32_genarray, write__float64_genarray), x[1]);
  });
}

function read_frames_term(read__int32_genarray, read__int64_genarray, read__float32_genarray, read__float64_genarray) {
  var partial_arg = read_frames(read__int32_genarray, read__int64_genarray, read__float32_genarray, read__float64_genarray);
  return Atdgen_codec_runtime.Decode.$$enum(
  /* :: */
  [
  /* tuple */
  ["Frames",
  /* `Decode */
  [427938126, function (param) {
    return Atdgen_codec_runtime.Decode.map(function (x) {
      return (
        /* `Frames */
        [-518380602, x]
      );
    }, partial_arg, param);
  }]],
  /* [] */
  0]);
}

var read_labels = read__1;
var write_labels = write__1;
export { read_labels, write_labels, read_bigdata, write_bigdata, read_frames, write_frames, read_indexed, write_indexed, read_term, write_term, read_indexed_term, write_indexed_term, read_frames_term, write_frames_term };
/* Bigdata_bs-SolvuuApi0 Not a pure module */